// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".top-toolbar[data-v-5c67ef4d]{max-width:100vw;padding:0!important;transition:height 2s}.top-toolbar--dense[data-v-5c67ef4d]{max-height:64px!important}.top-toolbar--transparent[data-v-5c67ef4d]{transition:background-color .3s}.top-toolbar__search--fade[data-v-5c67ef4d]{transition:opacity .3s}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
